import React from 'react';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function ProjectCards(props) {
  const buttonComponent =
    <Button variant="primary m-1" href={props.link} target="_blank">
      <i className="devicon-github-original">&nbsp;</i>
      View Project
    </Button>
  const tryButtonComponent =
    <Button variant="primary m-1" target="_blank" onClick={props.openModal}>
      <i className={props.onSiteIcon}>&nbsp;</i>
      Try it!
    </Button>
  const button = !!props.link ? buttonComponent : undefined
  const tryButton = !!props.onSiteIcon ? tryButtonComponent : undefined

  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        {button}
        {tryButton}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
